import { Segmented, Typography } from 'antd';
import { UnorderedListOutlined, ApartmentOutlined } from '@ant-design/icons';

const { Text } = Typography;

export type EquipeViewMode = 'lista' | 'time';

interface EquipeUnifiedPanelProps {
  view: EquipeViewMode;
  onViewChange: (view: EquipeViewMode) => void;
  listContent: React.ReactNode;
  teamContent: React.ReactNode;
  /** Texto curto sob o toggle (opcional). */
  hint?: string;
}

/**
 * Uma superfície de Equipe: mesmas pessoas, duas vistas.
 * Lista = escrita (adicionar/editar membro). Por time = hierarquia comercial.
 */
export function EquipeUnifiedPanel({
  view,
  onViewChange,
  listContent,
  teamContent,
  hint = 'Lista para cadastrar membros com login. Por time mostra a hierarquia comercial.',
}: EquipeUnifiedPanelProps) {
  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <Segmented
          value={view}
          onChange={(value) => onViewChange(value as EquipeViewMode)}
          options={[
            {
              label: 'Lista',
              value: 'lista',
              icon: <UnorderedListOutlined />,
            },
            {
              label: 'Por time',
              value: 'time',
              icon: <ApartmentOutlined />,
            },
          ]}
        />
        <Text type="secondary" className="text-xs sm:text-sm max-w-xl">
          {hint}
        </Text>
      </div>
      <div>{view === 'lista' ? listContent : teamContent}</div>
    </div>
  );
}

export function equipeViewFromSearchParam(
  tab: string | null,
  view: string | null
): EquipeViewMode {
  if (view === 'time' || view === 'times' || tab === 'times') return 'time';
  return 'lista';
}
